import { render, staticRenderFns } from "./ProductsTableArchived.vue?vue&type=template&id=425b64d0"
import script from "./ProductsTableArchived.vue?vue&type=script&lang=js"
export * from "./ProductsTableArchived.vue?vue&type=script&lang=js"
import style0 from "./ProductsTableArchived.vue?vue&type=style&index=0&id=425b64d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports